import React from 'react';
import {connect} from 'react-redux';

import {BaseRate, mapStateToProps} from './BaseRate.jsx';

import {addCouponRate as addCouponRateAction, addRate as addRateAction} from 'actions/creators/CouponRate';
import {makeBet as makeBetAction} from 'actions/creators/MakeBet';
import {requestBetTypes as requestBetTypesAction} from 'actions/creators/HistoryBet';

import {getRateDisplayValue} from 'rendering-commons';

class RegularRate extends BaseRate {
    constructor(props) {
        super(props);
    }

    render() {
        const {rate, outcomeIsBlocked} = this.props;

        if (rate === undefined) {
            return false;
        }

        const isVisible = rate.get('isVisible');

        if (!isVisible) {
            return false;
        }

        const rateName = rate.get('shortName');
        const rateValue = getRateDisplayValue(rate.get('value'));

        const isBlocked = rate.get('isBlocked') || outcomeIsBlocked;

        const outCls = 'out' + (isBlocked ? ' closed' : '');
        const rateCls = 'out-rate' + (isBlocked ? ' closed' : '');
        const conditionCls = 'out-cond' + (isBlocked ? ' closed' : '');

        return (<span key={rate.get('id')} ref="rate" className={outCls} onClick={this._onClick}>
                    <span className={conditionCls}>{rateName}</span>
                    <span className={rateCls}>{rateValue}</span>
                </span>
        );
    }
}

export default connect(mapStateToProps, {
    addCouponRateAction, makeBetAction, requestBetTypesAction, addRateAction
}, null, false)(RegularRate);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/rates/RegularRate.jsx